<template>
  <div>
    <div style="display: flex; position: relative; align-items: center">
      <div v-if="multiple" class="flex flex-wrap items-center gap-1" :class="readonly ? '' : 'cursor-pointer print-input'" @click.self="handleClickInput">
        <p v-if="showEmptyMessage && selectedData.length === 0 && readonly" class="w-full h-full">{{ emptyMessage }}</p>
        <vs-chip v-else v-for="chip in selectedData" :key="chip.id" @click="remove(chip)" :closable="!readonly" color="secondary" class="mb-0">
          {{ chip.com_name }}
        </vs-chip>
      </div>
      <ml-input v-else
                class="company-select-input w-full h-full"
                style="border-radius: 5px"
                :readonly="readonly"
                :value="selectCompany && selectCompany.com_name ? selectCompany.com_name : companyName"
                :placeholder="placeholder"
                @click="handleClickInput" />
      <vs-icon v-if="!readonly" icon-pack="feather" icon="icon-home" style="padding-left: 6px; padding-right: 6px; position: absolute; top: auto; right: 0; bottom: auto; font-size: 24px; border-left: 1px solid #cdcdcd"></vs-icon>
    </div>
    <popup-search-virtual-company
      ref="popupSearchCompany"
      :multiple="multiple"
      v-model="showPopup"
      :selectId="multiple ? selectCompanyId : (selectCompany ? selectCompany.id : selectCompanyId)"
      @on-company-selected="onCompanySelected"
      :title="popupTitle"
    />
  </div>
</template>

<script>
import PopupSearchVirtualCompany from "@/popup/PopupSearchVirtualCompany.vue";

export default {
  name: "VirtualCompanySelector",
  components: {PopupSearchVirtualCompany},
  props: {
    value: [Number, String, Array],
    placeholder: String,
    readonly: Boolean,
    multiple: Boolean,
    title: {
      type: String,
      default: "부서 검색",
    },
    showEmptyMessage: {
      type: Boolean,
      default: false,
    },
    emptyMessage: {
      type: String,
      default: "선택된 부서가 없습니다.",
    },
    companyName: String, // 선택한 회사의 이름 - 새로고침 시에 회사 이름이 보이지 않는 문제를 처리하기 위해, 부모 컴포넌트에서 회사 이름을 받아와서 처리
  },
  data() {
    return {
      showPopup: false,
      selectedData: this.value,
      selectCompanyId: "",
    };
  },
  watch: {
    value(data) {
      this.selectedData = data;
    },
    selectedData(data) {
      if (this.multiple) this.selectCompanyId = data.map((item) => item.id);
    },
  },
  computed: {
    selectCompany() {
      const list = this.$store.state.company.companyList;
      return list.find((company) => company.id === this.selectedData);
    },
    popupTitle() {
      return this.title;
    },
  },
  methods: {
    handleClickInput() {
      if (!this.readonly) {
        this.$refs.popupSearchCompany.loadCompanyList();
        this.showPopup = true;
      }
    },

    remove(chip) {
      if (this.readonly) return;

      this.selectedData = this.selectedData.filter((item) => item.id !== chip.id);
      this.selectCompanyId = this.selectedData.map((item) => item.id);

      this.$emit("input", this.selectCompanyId);
    },

    onCompanySelected(selectedData) {
      if (this.readonly) {
        // 읽기 전용일 때에는 선택 동작으로 넘어가지 않게 한다
        return;
      }

      if (this.multiple) {
        this.selectedData = selectedData;
        this.selectCompanyId = selectedData.map((item) => item.id);
        this.$emit("input", this.selectedData);
      } else {
        this.selectCompanyId = selectedData.id;
        this.$emit("input", selectedData.id);
      }
      this.$emit("select", selectedData);
    },
  },
};
</script>

<style>
.company-select-input .vs-input--input.normal {
  padding-right: 40px !important;
}
</style>
